import { AuthStore } from "../base/store/AuthStore";
import { ProjectStore } from "../base/store/ProjectStore";
import { MessageCenter } from "../base/kernel/MessageCenter";
import { RestAbortManager } from "../base/cutil/RestClient";
import { BrainClient } from "../base/api/BrainClient";
import { MeStore } from "../base/store/MeStore";
import { PersonalFunctionStore } from "../base/store/PersonalFunctionStore";
import { FunctionV2Store } from "../base/store/FunctionV2Store";
import { GlobalFunctionStore } from "../base/store/GlobalFunctionStore";
import { LocationManager } from "../base/port/LocationManager";
import { TopicService } from "../base/storyV2/service/TopicService";
import { CustomApiTransfromService } from "../base/storyV2/service/CustomApiTransfromService";
import { FunctionRegistry } from "../base/storyV2/function/FunctionRegistry";
import { AdapterRegistry } from "../base/storyV2/adapter/AdapterRegistry";
import { StorageManager } from "../base/port/StorageManager";
import { StoryManager } from "../base/storyV2/domain/StoryManager";
import { ToolPieceStore } from "../base/store/ToolPieceStore";
import { BlueprintsStore } from "../base/store/BlueprintsStore";
import { FotClient } from "../base/api/FotClient";
import { FotAuthStore } from "../base/store/FotAuthStore";
import { CommonHeaderService } from "../base/storyV2/service/CommonHeaderService";
import { AiAppThemeStore } from "../cases/theme/appTheme/AiAppThemeStore";
import { ChatAppThemeStore } from "../cases/theme/chatTheme/ChatAppThemeStore";
import { FontStore } from "../cases/theme/fontTheme/FontStore";
import { SubscriptionStore } from "../cases/store/SubscriptionStore";
import { PreferencesStore } from "../base/store/PreferencesStore";
import { WebConfigStore } from "../cases/webconfig/WebConfigStore";
import { PublishSubscriptionStore } from "../cases/store/PublishSubscriptionStore";
import { GeneratePromptService } from "../base/storyV2/service/GeneratePromptService";
import { WebsocketService } from "../base/storyV2/service/WebsocketService";
export class RegisterBasic {
    static configure(container, params) {
        const it = (serviceIdentifier) => {
            return container.get(serviceIdentifier);
        };
        container.bind(StorageManager).toConstantValue(params.defaultStorageManager);
        container.bind(ProjectStore).toConstantValue(new ProjectStore());
        container.bind(AuthStore).toConstantValue(new AuthStore(params.cookieStorageManager));
        container.bind(RestAbortManager).toConstantValue(new RestAbortManager());
        container.bind(BrainClient).toConstantValue(new BrainClient(it(AuthStore), it(RestAbortManager), it(ProjectStore)));
        container.bind(MeStore).toConstantValue(new MeStore(it(BrainClient)));
        container.bind(PersonalFunctionStore).toConstantValue(new PersonalFunctionStore(it(BrainClient)));
        container.bind(FunctionV2Store).toConstantValue(new FunctionV2Store(it(BrainClient)));
        container.bind(GlobalFunctionStore).toConstantValue(new GlobalFunctionStore(it(BrainClient)));
        container.bind(LocationManager).toConstantValue(params.locationManager);
        container.bind(TopicService).toConstantValue(new TopicService(it(MeStore), it(AuthStore)));
        container.bind(CommonHeaderService).toConstantValue(new CommonHeaderService(it(AuthStore), it(ProjectStore)));
        container.bind(CustomApiTransfromService).toConstantValue(new CustomApiTransfromService(it(BrainClient)));
        container.bind(GeneratePromptService).toConstantValue(new GeneratePromptService(it(BrainClient)));
        container
            .bind(FunctionRegistry)
            .toConstantValue(new FunctionRegistry(it(BrainClient), it(GlobalFunctionStore), it(PersonalFunctionStore), it(AuthStore), it(FunctionV2Store), it(MeStore)));
        container
            .bind(AdapterRegistry)
            .toConstantValue(new AdapterRegistry(it(PersonalFunctionStore), it(GlobalFunctionStore), it(FunctionV2Store), it(MeStore)));
        container.bind(MessageCenter).toConstantValue(new MessageCenter(it(AuthStore)));
        container
            .bind(StoryManager)
            .toConstantValue(new StoryManager(it(AdapterRegistry), it(FunctionRegistry), it(RestAbortManager), it(MessageCenter), it(CustomApiTransfromService), it(GeneratePromptService)));
        container.bind(ToolPieceStore).toConstantValue(new ToolPieceStore(it(BrainClient)));
        container.bind(BlueprintsStore).toConstantValue(new BlueprintsStore(it(BrainClient)));
        container.bind(WebsocketService).toConstantValue(new WebsocketService(it(MessageCenter)));
        container.bind(FotAuthStore).toConstantValue(new FotAuthStore(params.cookieStorageManager, it(AuthStore)));
        container.bind(FotClient).toConstantValue(new FotClient(it(FotAuthStore), it(ProjectStore), it(LocationManager)));
        container.bind(AiAppThemeStore).toConstantValue(new AiAppThemeStore());
        container.bind(ChatAppThemeStore).toConstantValue(new ChatAppThemeStore());
        container.bind(FontStore).toConstantValue(new FontStore());
        container.bind(PreferencesStore).toConstantValue(new PreferencesStore(it(BrainClient)));
        container.bind(WebConfigStore).toConstantValue(new WebConfigStore(it(FotClient)));
        container
            .bind(SubscriptionStore)
            .toConstantValue(new SubscriptionStore(it(BrainClient), it(PreferencesStore), it(WebConfigStore)));
        container.bind(PublishSubscriptionStore).toConstantValue(new PublishSubscriptionStore(it(BrainClient)));
    }
}
